export default __webpack_public_path__ + "static/media/Bjorn_Icon.67417993.png";